import { __assign, __rest } from "tslib";
import React from "react";
import { View, Image } from "react-native";
import { PnmacNavigation, PnmacHtmlToNative, PnmacImage } from "pnmac-universal-components";
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from "../../redux/events/events";
import BannerView from '../../v2/BannerView';
import { textStyle } from '../../v2/theme';
var EscrowAnalysisDescriptionBanner = function (_a) {
  var _b, _c, _d;
  var matches = _a.matches,
    translations = _a.translations,
    props = __rest(_a, ["matches", "translations"]);
  var achExist = ((_d = (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.paymentModel) === null || _c === void 0 ? void 0 : _c.pendingPayments) === null || _d === void 0 ? void 0 : _d.find(function (s) {
    return s.paymentType == 201309;
  })) != null;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      marginTop: 10
    }
  }, /*#__PURE__*/React.createElement(BannerView, {
    style: [textStyle.bannerViewWarning, {
      marginBottom: 10
    }]
  }, achExist ? /*#__PURE__*/React.createElement(View, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations.EAPAutoPay
  })) : /*#__PURE__*/React.createElement(View, {
    style: {
      padding: 2
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations.EAPHomeBanking
  }))), /*#__PURE__*/React.createElement(BannerView, {
    style: {
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    onClick: function (e) {
      var target = e.target.toString();
      if (target != null && target.indexOf('/Loan/Escrow') > -1) {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Page Escrow Link Clicked", 0);
      } else if (target != null && target.indexOf('/StatementsAndDocuments') > -1) {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Page Statement & Documents Link Clicked", 0);
      }
    },
    value: translations.EAViewEscrowInstruction,
    navigation: {
      navigate: function (params) {
        if (params === "StatementsAndDocuments") {
          props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Statement & Documents Link Clicked", 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/StatementsAndDocuments"
            }
          }, props));
        } else if (params === "Loan/Escrow") {
          props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Link Clicked", 0);
          PnmacNavigation(__assign({
            action: {
              pathname: "/Loan/Escrow"
            }
          }, props));
        }
      }
    }
  }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    onClick: function (e) {
      var target = e.target.toString();
      if (target != null && target.indexOf('/Home/FAQ') > -1) {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Page FAQ Clicked", 0);
      }
    },
    value: translations.EAViewFAQInstruction,
    navigation: {
      navigate: function () {
        props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Escrow Page FAQ Clicked", 0);
        PnmacNavigation(__assign({
          action: {
            pathname: "/Home/FAQ"
          }
        }, props));
      }
    }
  })));
};
export default EscrowAnalysisDescriptionBanner;